import _get from 'lodash/get';
import config, { i18nNames, youbora as youboraConfig } from '@bedrock-rdk/config';
import { DEVICE_CODE, THIRD_PARTY_KEY } from './youbora.constants';

export const engineName = 'youbora';

// NOTE: youboralib is ~190 KB and only reports on playback, so the engine is loaded on demand.
// The third-party service awaits the `engine` factory, so returning a promise is supported.
let loadedEngine;

const loadEngine = () =>
  // eslint-disable-next-line import/no-unresolved
  import(
    /* webpackChunkName: "engine.youbora" */
    './youbora.engine'
  ).then(module => {
    loadedEngine = module.default;

    return loadedEngine;
  });

export const getEngine = () => {
  const { analytics } = config;
  const initParams = _get(analytics, ['initParams', engineName]) || {};

  return {
    thirdPartyServiceConfig: {
      key: engineName,
      name: engineName,
      bootMethod: () => require('./youbora.boot'),
      engine: loadEngine,
      taggingPlan: _get(analytics, ['taggingPlans', engineName], {}),
      initParams: {
        ...initParams,
        accountCode: initParams.accountCode || youboraConfig.accountCode,
        deviceCode: initParams.deviceCode || DEVICE_CODE,
        appName: initParams.appName || i18nNames.appDisplayName,
        thirdPartyKey: THIRD_PARTY_KEY,
      },
    },
    cleanup: () => {
      if (loadedEngine) {
        loadedEngine.destroy();
      }
    },
  };
};
